import React, {FC} from "react";
import {Form} from "react-bootstrap";
import {DatePicker} from "components";
import {PushNotificationSearchGetParams} from "services/supportService";

export enum SearchParams {
    UserKey,
    Date,
    RecipientKey,
    EventType,
    Skip,
    Take,
}


interface Props {
    visibleParams?: SearchParams[];
    params: PushNotificationSearchGetParams;
    setParams: React.Dispatch<React.SetStateAction<PushNotificationSearchGetParams>>;
    onSearch: () => void;
}

const EVENT_TYPES = ['MatchOnline', 'NewUserNearby', 'OutgoingLikeReminder', 'SmartIntro'] as const;

export const PushNotificationSearchParams: FC<Props> = ({visibleParams, onSearch, params, setParams}) => {
    const isParamVisible = (p: SearchParams) => {
        return !visibleParams || visibleParams?.includes(p);
    };

    return (
        <div className="row gy-2 gx-3 align-items-center">
            {isParamVisible(SearchParams.UserKey) && (
                <div className="col">
                    <label className="visually-hidden" htmlFor="userKeyInput">Пользователь</label>
                    <Form.Control
                        type="text"
                        id="userKeyInput"
                        placeholder="User Key"
                        value={params.userKey}
                        onChange={e => setParams(pr => ({
                            ...pr,
                            userKey: e.target.value
                        }))}
                    />
                </div>
            )}

            {isParamVisible(SearchParams.Date) && (
                <>
                    <div className="col">
                        <Form.Group>
                            <DatePicker
                                value={params.dateFrom}
                                label="С"
                                type="control"
                                onChange={(d) => setParams(pr => ({...pr, dateFrom: d}))}
                            />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group>
                            <DatePicker
                                value={params.dateTo}
                                label="По"
                                type="control"
                                onChange={(d) => setParams(pr => ({...pr, dateTo: d}))}
                            />
                        </Form.Group>
                    </div>
                </>
            )}

            {isParamVisible(SearchParams.RecipientKey) && (
                <div className="col">
                    <label className="visually-hidden" htmlFor="recipientKeyInput">Recipient Key</label>
                    <Form.Control
                        type="text"
                        id="recipientKeyInput"
                        placeholder="Получатель"
                        value={params.recipientKey ? params.recipientKey : undefined}
                        onChange={e => setParams(pr => ({
                            ...pr,
                            recipientKey: e.target.value
                        }))}
                    />
                </div>
            )}

            {isParamVisible(SearchParams.EventType) && (
                <div className="col">
                    <label className="visually-hidden" htmlFor="eventTypeSelect">Тип</label>
                    <Form.Select
                        id="eventTypeSelect"
                        value={params.eventType ? params.eventType : undefined}
                        onChange={e => setParams(pr => ({
                            ...pr,
                            eventType: e.target.value as PushNotificationSearchGetParams['eventType']
                        }))}
                    >
                        <option value="">All Event Types</option>
                        {EVENT_TYPES.map(type => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                    </Form.Select>
                </div>
            )}

            <div className="col-auto">
                <button className="btn btn-primary" onClick={onSearch}>Поиск</button>
            </div>
        </div>
    );
};